import { render } from "./OnlineCareVideo.vue?vue&type=template&id=b5940ae8&scoped=true&ts=true"
import script from "./OnlineCareVideo.vue?vue&type=script&lang=ts"
export * from "./OnlineCareVideo.vue?vue&type=script&lang=ts"

import "./OnlineCareVideo.vue?vue&type=style&index=0&id=b5940ae8&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5940ae8"]])

export default __exports__